<template>
  <div class="sheet-component">
    <button
      class="sheet-close-button"
      @click="handleSheetClose"
    >
      <icon
        :name="'cross-thin'"
        class="sheet-close-icon"
      />
    </button>
    <content-sources-page
      v-if="sheetType === 'content-source'"
      :options="options"
    />
    <progress-info-page
      v-if="sheetType === 'progress-info'"
    />
  </div>
</template>

<script>
import Icon from '@/components/singletons/icon.vue';
import ContentSourcesPage from '@/components/content-sources/page.vue';
import ProgressInfoPage from '@/components/progress/progress-info-page.vue';

export default {
  components: { Icon, ContentSourcesPage, ProgressInfoPage },
  props: {
    sheetType: {
      type: String,
    },
    options: {
      type: Object,
    },
  },
  emits: ['hide'],
  methods: {
    handleSheetClose() {
      this.$emit('hide');
    },
  },
};
</script>

<style lang="scss" scoped>
.sheet-component {
  background-color: white;
  border-bottom: 8px solid #00dbfb;
  border-radius: 4px 0 0 4px;
  box-sizing: border-box;
  height: 100%;
  max-width: 400px;
  overflow-y: auto;
  position: absolute;
  padding: 48px 32px;
  right: 0;

  .sheet-close-button {
    background: transparent;
    position: absolute;
    right: 32px;
    top: 32px;

    .sheet-close-icon {
      height: 16px;
      width: 16px;
    }
  }

  @include breakpoint(small) {
    border-radius: 12px 12px 0 0;
    border: none;
    bottom: 0;
    height: auto;
    left: 0;
    max-width: 100%;
    padding: 32px 16px;
    top: 10%;

    .sheet-close-button {
      right: 16px;
      top: 16px;
    }
  }
}
</style>
